import { useFormik } from "formik";
import * as Yup from "yup";
import React from "react";
import { Input } from "src/shadcn/components/ui";
import { cn } from "src/helpers";
import { Button } from "../../shadcn/components/ui/button";

// const MAX_FILE_SIZE = 100 * 1024 * 1024;
const SUPPORTED_FORMATS = ["application/pdf"];

interface UploadFileProps {
  title: string;
  setOpen: (val: boolean) => void;
  isOpen: boolean;
  handleSubmit: (postData: any) => void;
  isLoading: boolean;
}
const UploadFile: React.FC<UploadFileProps> = ({ title, setOpen, isOpen, handleSubmit, isLoading }) => {
  const formik = useFormik({
    initialValues: {
      file: null,
    },
    validationSchema: Yup.object({
      file: Yup.mixed()
        .required("File is required")
        .test("fileSize", "File size must be less than 15MB", (value) => {
          if (value) {
            const file = value as File;
            // Convert size to bytes if necessary
            const fileSizeInBytes = file.size;
            return fileSizeInBytes <= 15728640; // 1MB in bytes
          }
          return true;
        })
        .test("fileType", "Unsupported file format", (value) => {
          const file = value as File;
          return file && SUPPORTED_FORMATS.includes(file.type);
        }),
    }),
    onSubmit: (values) => {
      let formData: any = new FormData();
      if (values?.file) {
        formData.append("file", values?.file);
        handleSubmit(formData);
      }
      // for (let pair of formData.entries()) {
      // }
    },
  });

  return (
    <div className="flex justify-center items-center ">
      <form onSubmit={formik.handleSubmit} className="space-y-4">
        <h2 className="text-primary font-semibold text-lg"> {title}</h2>
        <div>
          <Input
            type="file"
            name="uploadFile"
            // accept="./pdf"
            onChange={(e: any) => {
              const file = e.target?.files[0];
              formik.setFieldValue("file", file);
            }}
            className="block border rounded p-2 mt-1"
          />
          <div className={cn("text-xs font-medium text-destructive")}>
            {formik.touched.file && formik.errors.file && formik.errors.file}
          </div>
        </div>
        <div className="flex justify-between space-x-4">
          <Button type="submit" className="w-full">
            {isLoading ? "Please Wait" : "Upload File"}
          </Button>
          <Button type="submit" className="w-full" onClick={() => setOpen(!isOpen)}>
            Cancel
          </Button>
        </div>
      </form>
    </div>
  );
};

export default UploadFile;
